import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes safely.
 * Combines clsx for conditional classes and tailwind-merge for conflict resolution.
 *
 * @example
 * cn('px-4 py-2', 'px-6') // → 'py-2 px-6'
 * cn('base-class', isActive && 'active-class')
 * cn(buttonVariants({ variant: 'primary' }), className)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
